import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_PAYROLL_REQUEST = "POST_PAYROLL_REQUEST";
export const POST_PAYROLL_SUCCESS = "POST_PAYROLL_SUCCESS";
export const POST_PAYROLL_ERROR = "POST_PAYROLL_ERROR";

//* ACTIONS ------------------------------------------------
export const postPayrollRequest = (payload = {}, callback) => ({
  type: POST_PAYROLL_REQUEST,
  payload,
  callback,
});

export const postPayrollSuccess = () => ({
  type: POST_PAYROLL_SUCCESS,
});

export const postPayrollError = (error) => ({
  type: POST_PAYROLL_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postPayrollServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/payrolls", options);
};
